(() => {
  const dialog = document.getElementById('KidsCharacterDialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const profiles = [...dialog.querySelectorAll('[data-kids-character-profile]')];
  const closeButton = dialog.querySelector('[data-kids-character-close]');
  let opener = null;

  document.querySelectorAll('[data-kids-character-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const profile = profiles.find((item) => item.dataset.kidsCharacterProfile === button.dataset.kidsCharacterOpen);
      if (!profile) return;

      profiles.forEach((item) => { item.hidden = item !== profile; });
      dialog.setAttribute('aria-label', profile.querySelector('h2').textContent.trim());
      opener = button;
      dialog.showModal();
      closeButton.focus();
    });
  });

  closeButton.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (opener && opener.isConnected) opener.focus();
  });
})();
